module.exports = __webpack_public_path__ + "static/media/carlton_blues.ec6d9fb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/carlton_blues.mp3
// module id = Y5PX
// module chunks = 0